export const ABOUT_US_CONTENT = {
  TITLE: 'About Us',
  SUBTITLE:
    'Quantitative strategy provider delivering data-driven, low-risk solutions through proprietary technology.',

  SECTIONS: {
    ABOUT: {
      TEXT: [
        'MarQ Capital is a London-based Quantitative Strategy Provider that delivers institutional-grade, algorithmic trading strategies through its proprietary engine, SwingVision.',
        'We serve Professional Clients exclusively, including Asset Management Companies (AMCs), Family Offices and High-Net-Worth Individuals (HNWIs).',
        'Built on principles of transparency, performance and partnership, MarQ Capital combines cutting-edge quantitative research with execution infrastructure designed for scalability, efficiency and compliance.'
      ]
    },

    LEADERSHIP: {
      TITLE: 'Leadership',
      TEXT: [
        'Our team combines decades of experience in quantitative finance, systematic trading, risk management and regulatory compliance.',
        'Led by a founder with deep expertise in algorithmic systems and financial engineering, MarQ Capital is structured to support the evolving needs of institutional capital.',
        'Full biographies and credentials are available upon request for prospective partners and clients.'
      ]
    },

    MISSION: {
      TITLE: 'Mission',
      TEXT: [
        'Our mission is to transform quantitative research into scalable, capital-efficient strategies that deliver consistent, uncorrelated alpha.',
        'We operate with institutional discipline, regulatory integrity and technological rigor, ensuring that every strategy we deploy meets the highest standards of transparency and auditability.',
        'MarQ Capital exists to empower professional investors with tools that adapt to market complexity while maintaining strict risk controls and operational excellence.'
      ]
    },

    PRINCIPLES: {
      TITLE: 'What MarQ Capital stands for',
      INTRO:
        'Our 4 principles are the pillars of our culture that guide all our actions: Integrity, Innovation, Transparency, and Customer Focus.',
      PRINCIPLES_LIST: [
        {
          title: 'Integrity',
          text: 'We operate with ethics, responsibility, and full transparency in every decision, ensuring trust at every level of our quantitative strategy execution.'
        },
        {
          title: 'Innovation',
          text: 'We explore and implement new solutions with agility, creativity, and technical rigour to enhance performance and adapt to evolving market needs.'
        },
        {
          title: 'Transparency',
          text: 'We communicate clearly, giving clients the clarity and context needed to make confident, data-informed decisions.'
        },
        {
          title: 'Client Focus',
          text: "We tailor our quantitative strategies to each client's objectives, aligning with their mandates and placing their priorities at the core of every decision. Always."
        }
      ]
    },

    FOOTER_NOTE:
      'At MarQ Capital, our commitment is defined by our values and our discipline. We continuously refine our systems and processes to deliver exceptional results while maintaining the highest standards of integrity and transparency in all our operations.'
  }
};

export const CSR_CONTENT = {
  TITLE: 'Acting on Values, Not Visibility',
  BREADCRUMBS: [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/about-us' },
    {
      label: 'CSR',
      path: '/about-us/csr'
    }
  ],
  SECTIONS: {
    INTRO: {
      TEXT: "At MarQ Capital, we believe that every action should reflect the values and ethics that define us. Founded by Luís Marques, the company is committed to making a positive social impact, not through promotion, but through responsibility, accountability and transparency. We don't share our efforts to be seen. We share them to remain true to who we are."
    },
    GIVING: {
      TITLE: 'A Personal Commitment to Social Transformation',
      TEXT: "Luís Marques is deeply committed to addressing some of society's most pressing challenges, including poverty, education and inequality. His involvement is not symbolic, it's driven by a genuine desire to create meaningful, lasting change in the lives of the most vulnerable."
    },
    FOUNDER_GADIC: {
      TITLE: 'Transforming Lives in the Democratic Republic of Congo',
      TEXT: [
        "In 2012, Luís Marques founded GADIC (Groupe d'Appui pour le Développement Intégral du Congo), a non-profit organisation based in the Democratic Republic of Congo. Focused on addressing poverty and inequality, GADIC promotes social development through initiatives such as building primary schools and delivering community-focused programmes. Since its inception, the organisation has helped transform lives and expand access to education in some of the region's most vulnerable areas.",
        'At MarQ Capital, we support initiatives that promote equitable progress, where education and equality evolve hand in hand. Whether through partnerships or direct social action, our efforts reflect a vision of opportunity and sustainability, with a clear focus on long-term social and environmental impact.',
        "To learn more about GADIC's initiatives or to contribute to their mission, please visit their website at gadic.org."
      ],
      LINKS: [
        {
          word: 'gadic.org',
          url: 'https://www.gadic.org',
          color: 'var(--primary-blue)',
          textDecoration: 'underlined',
          newTab: true
        }
      ]
    },
    TAX: {
      TITLE: 'A Transparent and Responsible Tax Approach',
      TEXT: 'MarQ Capital Group has an exclusively equity fund that is managed by its algorithms, ensuring strong internal alignment with performance. All profits from the fund are subject to UK corporation tax, with annual financial reports submitted to HMRC. The group is fully committed to tax compliance and responsible tax practices, in strict alignment with its formal tax strategy.',
      LINKS: [
        {
          word: 'Tax Strategy',
          url: '/legal/tax-strategy',
          color: 'var(--neutral-gray-light)',
          textDecoration: 'underlined',
          newTab: false
        }
      ]
    },
    DATA_CENTRES: {
      TITLE: 'Where High Performance Meets Low Impact',
      TEXT: 'Our operations rely on complex models and intensive data processing, increasing the demand for high-performance computing. To reduce our environmental footprint, we offset all emissions, including those generated by our data centres. In 2025, we began migrating our servers to Norway, where they now run entirely on renewable hydroelectric energy, reinforcing our long-term commitment to sustainability and responsible infrastructure.'
    },
    OTHER_RESPONSIBILITIES: {
      TITLE: 'Empowering Impact, Not Attention',
      LIST_ITEMS: [
        {
          title: 'Ethical Operations',
          text: "Our focus is not on being admired for social action—it's on taking action rooted in values."
        },
        {
          title: 'Accountability',
          text: 'These initiatives reflect our belief that responsibility is not an option, but an expectation.'
        },
        {
          title: 'Living Our Values',
          text: "At MarQ Capital, we don't promote our values. We live them, every day, with purpose and clarity."
        }
      ]
    },
    FOOTER_NOTE:
      'We continuously adapt and enhance our approach to contribute to a more sustainable and equitable future. Want to know more about our social initiatives? Please get in touch.'
  }
};
